export default {
  showInfo: false,
  showDebug: false,
  showWarn: true,
  showError: true
};